import { resolvePageComponent } from '@adonisjs/inertia/helpers'
import { createInertiaApp } from '@inertiajs/react'
import { CssBaseline, ThemeProvider } from '@mui/material'
import { SnackbarProvider } from 'notistack'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import { store } from './store'
import theme from './theme'

const appName = import.meta.env.VITE_APP_NAME || 'Video KYC | KriyamAi'

// const StyledMaterialDesignContent = styled(Box)(() => ({
//   '&.notistack-MuiContent-success': {
//     backgroundColor: '#2D7738',
//   },
//   '&.notistack-MuiContent-error': {
//     backgroundColor: '#970C0C',
//   },
// }));

createInertiaApp({
  progress: { color: '#5468FF' },
  title: (title) => `${title} - ${appName}`,
  resolve: (name) => {
    console.log(name)

    return resolvePageComponent(`../pages/${name}.tsx`, import.meta.glob('../pages/**/*.tsx'))
  },
  setup({ el, App, props }) {
    // hydrateRoot(el, <App {...props} />)
    createRoot(el).render(
      <BrowserRouter>
        <Provider store={store}>
          <ThemeProvider theme={theme}>
            <CssBaseline />
            <App {...props} />
            <SnackbarProvider autoHideDuration={5000} />
          </ThemeProvider>
        </Provider>
      </BrowserRouter>
    )
  },
})
